import { ORDER_BILLING_MESSAGES, OrderBillingMessages } from "./order-billing.messages";
import { ORDER_FOOTER_MESSAGES, OrderFooterMessages } from "./order-footer.messages";
import { ORDER_ITEM_LIST, OrderItemListMessages } from "./order-Item-list.messages";
import { ORDER_OBSERVATION_MESSAGES, OrderObservationMessages } from "./order-observation.messages";
import { ORDER_PAYMENT_MESSAGES, OrderPaymentMessages } from "./order-payment.messages";
import {
  ORDER_SHIPPING_MESSAGES,
  OrderShippingMessages,
} from "./order-shipping-Information.messages";
import { ORDER_SUMMARY_MESSAGES, OrderSummaryMessages } from "./order-summary.messages";
import { ORDER_TRACKING_MESSAGES, OrderTrackingMessages } from "./order-tracking.messages";
import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "../action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "../layout/sidebar";

export type OrderDetailsMessages = SidebarMessages &
  ActionButtonMessages &
  OrderItemListMessages &
  OrderTrackingMessages &
  OrderSummaryMessages &
  OrderBillingMessages &
  OrderShippingMessages &
  OrderPaymentMessages &
  OrderObservationMessages &
  OrderFooterMessages & {
    //Titles
    orderDetailsTitle: string;
    orderPrintTitle: string;
    cardTitle: string;
    orderBreadCrumbTitle: string;

    //Labels
    orderLabel: string;
    channelLabel: string;

    //Errors
    errorLoadingOrderDetails: string;
    errorLoadingOrderPdf: string;
    orderNotFoundAlt: string;
    noSalesChannelInformed: string;

    //Tabs
    orderDetailsSection: string;
    chatSection: string;
  };

export const ORDER_DETAILS_MESSAGES: OrderDetailsMessages = {
  //Titles
  orderDetailsTitle: "Detalhes do Pedido",
  cardTitle: "Detalhes do Pedido",
  orderBreadCrumbTitle: "Pedidos",
  orderPrintTitle: "Imprimir",

  //Labels
  orderLabel: "Pedido",
  channelLabel: "Canal",

  //Errors
  errorLoadingOrderDetails: "Erro ao carregar detalhes do pedido",
  errorLoadingOrderPdf: "Não foi possível gerar o PDF do pedido.",
  orderNotFoundAlt: "Pedido não encontrado",
  noSalesChannelInformed: "Nenhum canal de venda informado",

  //Tabs
  orderDetailsSection: "Detalhes",
  chatSection: "Mensagens",

  ...ORDER_FOOTER_MESSAGES,
  ...ORDER_OBSERVATION_MESSAGES,
  ...ORDER_BILLING_MESSAGES,
  ...ORDER_TRACKING_MESSAGES,
  ...ORDER_ITEM_LIST,
  ...ORDER_SHIPPING_MESSAGES,
  ...ORDER_SUMMARY_MESSAGES,
  ...ORDER_PAYMENT_MESSAGES,

  ...SIDEBAR_MESSAGES,
  ...ACTION_BUTTON_MESSAGES,
};
